import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";

const facebookShareLink = "https://www.facebook.com/sharer/sharer.php";
const twitterShareLink = "https://twitter.com/intent/tweet?";
const linkedInShareLink = "http://www.linkedin.com/shareArticle?mini=true&url=";

const FacebookShareSocial = () => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    setUrl(
      `${facebookShareLink}?u=${encodeURIComponent(
        document.URL
      )}&t=${encodeURIComponent(document.URL)}`
    );
  }, []);
  return (
    <a href={url} title="Share on Facebook" target="_blank" rel="noreferrer">
      <ShareSocial sx={{ background: "#0b85ee" }}>
        <FontAwesomeIcon icon={faFacebookF} />
      </ShareSocial>
    </a>
  );
};

const TwitterShareSocial = () => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    setUrl(
      `${twitterShareLink}text=${encodeURIComponent(
        document.title
      )}%0A${encodeURIComponent(document.URL)}`
    );
  }, []);
  return (
    <a href={url} title="Tweet" target="_blank" rel="noreferrer">
      <ShareSocial sx={{ background: "#1c9cea" }}>
        <FontAwesomeIcon icon={faTwitter} />
      </ShareSocial>
    </a>
  );
};

const LinkedInShareSocial = () => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    setUrl(
      `${linkedInShareLink}${encodeURIComponent(
        document.URL
      )}&title=${encodeURIComponent(document.title)}`
    );
  }, []);
  return (
    <a href={url} title="Share on LinkedIn" target="_blank" rel="noreferrer">
      <ShareSocial sx={{ background: "#0a66c2" }}>
        <FontAwesomeIcon icon={faLinkedinIn} />
      </ShareSocial>
    </a>
  );
};

export const ShareSocials = () => (
  <ShareSocialsContainer>
    <FacebookShareSocial />
    <TwitterShareSocial />
    <LinkedInShareSocial />
  </ShareSocialsContainer>
);

const ShareSocialsContainer = styled(Box)`
  display: flex;
`;
const ShareSocial = styled(Box)`
  width: 3rem;
  height: 3rem;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-0.25rem);
  }
`;
